import React from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { useSeo } from '../hooks/useSeo';
export function Datenschutz() {
  useSeo({
    title: 'Datenschutzerklärung | Hot Sales Girls Academy',
    description: 'Informationen zur Verarbeitung personenbezogener Daten auf der Website der Hot Sales Girls Academy gemäß DSGVO.',
    path: '/datenschutz',
    noIndex: true
  });
  return <div className="min-h-screen w-full" data-id="element-458" data-mp="1df33bmozon4c">
      <div className="pink-panel relative" data-id="element-459" data-mp="zftvpbeun1bz">
        <div className="relative z-10" data-id="element-460" data-mp="zf22u8cmzhpe">
          <Navbar data-id="element-461" data-mp="zi7otepyy3gw" />

          <main className="relative w-full bg-cream px-4 pb-14 pt-8 sm:px-6 sm:pb-20 sm:pt-12" data-id="element-462" data-mp="14eoieofxta1d">
            <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-463" data-mp="3k6c9424cy6bq" />
            <span aria-hidden="true" className="gold-glitter-extra" data-id="element-464" data-mp="3k8f8hcrehbt4" />
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="mx-auto max-w-3xl" data-id="element-465" data-mp="3p6qjhqtflscx">
              <div className="text-center" data-id="element-466" data-mp="1bcb2ftli301m">
                <span className="inline-block rounded-full border border-gold/60 px-5 py-2 text-xs font-semibold uppercase tracking-[0.25em] text-neutral-700" data-id="element-467" data-mp="1pa9c4lovm8as">
                  Datenschutz
                </span>
                <h1 className="mt-6 font-sans text-4xl font-medium text-neutral-900 sm:text-5xl" data-id="element-468" data-mp="1y9me6tao7ulh">
                  Datenschutzerklärung
                </h1>
              </div>

              <div className="mt-8 space-y-7 text-sm leading-relaxed text-neutral-700" data-id="element-469" data-mp="2810g17q3h6hs">
                <section data-id="element-470" data-mp="231nxgz69all0">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-471" data-mp="232fg79er8otv">
                    1) Information über die Erhebung personenbezogener Daten und Kontaktdaten des
                    Verantwortlichen
                  </h2>
                  <p className="mt-2" data-id="element-472" data-mp="2cxh82d0f0505">
                    1.1 Wir freuen uns, dass Sie unsere Website besuchen und bedanken uns für Ihr
                    Interesse. Im Folgenden informieren wir Sie über den Umgang mit Ihren
                    personenbezogenen Daten bei der Nutzung unserer Website. Personenbezogene Daten
                    sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                  </p>
                  <p className="mt-2" data-id="element-473" data-mp="33ranudhihjta">
                    1.2 Verantwortlicher für die Datenverarbeitung auf dieser Website im Sinne der
                    Datenschutz-Grundverordnung (DSGVO) ist:
                  </p>
                  <p className="mt-2 font-semibold text-neutral-900" data-id="element-474" data-mp="3csqwafornbuv">
                    Hot Sales Girls – Mermaid Beauty Aesthetics FZCO
                  </p>
                  <p data-id="element-475" data-mp="1ido9ipr3q7vn">Dubai Silicon Oasis, DDP, Building A1</p>
                  <p data-id="element-476" data-mp="1if93ad5ldmsg">Dubai, Vereinigte Arabische Emirate</p>
                  <p data-id="element-477" data-mp="1nbpuxhc02jaa">E-Mail: info@hotsalesgirls.com</p>
                  <p className="mt-2" data-id="element-478" data-mp="1necb25cyi744">
                    1.3 Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
                    personenbezogener Daten und anderer vertraulicher Inhalte (z. B. Bestellungen
                    oder Anfragen an den Verantwortlichen) eine SSL- bzw. TLS-Verschlüsselung. Eine
                    verschlüsselte Verbindung erkennen Sie an der Zeichenfolge „https://“ und dem
                    Schloss-Symbol in Ihrer Browserzeile.
                  </p>
                </section>

                <section data-id="element-479" data-mp="1tshuzrxtr0cb">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-480" data-mp="1ttaty6qjkljw">
                    2) Datenerfassung beim Besuch unserer Website
                  </h2>
                  <p className="mt-2" data-id="element-481" data-mp="1jvd4xh0uykq8">
                    Bei der rein informatorischen Nutzung unserer Website, also wenn Sie sich nicht
                    registrieren oder uns anderweitig Informationen übermitteln, erheben wir nur
                    solche Daten, die Ihr Browser an unseren Server übermittelt („Server-Logfiles“).
                    Folgende Daten werden dabei erhoben: • Besuchte Seite unserer Website • Datum und
                    Uhrzeit zum Zeitpunkt des Zugriffs • Menge der gesendeten Daten in Byte • Quelle/
                    Verweis, von welchem Sie auf die Seite gelangten • Verwendeter Browser •
                    Verwendetes Betriebssystem • Verwendete IP-Adresse (ggf. anonymisiert) Die
                    Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres
                    berechtigten Interesses an der Verbesserung der Stabilität und Funktionalität
                    unserer Website.
                  </p>
                </section>

                <section data-id="element-482" data-mp="2azzc4y1k12or">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-483" data-mp="2azfw5mvgsodd">
                    3) Cookies &amp; Consent Tool
                  </h2>
                  <p className="mt-2" data-id="element-484" data-mp="zmdeeohmpsrm">
                    Diese Website verwendet Cookies. Dabei kommen auch sogenannte „Consent Tools“ zum
                    Einsatz, die Ihre Zustimmung zur Verwendung von Cookies einholen und
                    dokumentieren. Die Verwendung technisch notwendiger Cookies erfolgt auf Basis von
                    Art. 6 Abs. 1 lit. f DSGVO, alle anderen Cookies nur mit Ihrer Einwilligung (Art.
                    6 Abs. 1 lit. a DSGVO).
                  </p>
                  <p className="mt-2" data-id="element-485" data-mp="2v2lofti2mxq1">Details entnehmen Sie bitte unserer [Cookie-Richtlinie].</p>
                </section>

                <section data-id="element-486" data-mp="2q5bsdv06fnt8">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-487" data-mp="2q1xqenvfdgmb">4) Hosting</h2>
                  <p className="mt-2" data-id="element-488" data-mp="33xjn7h7wh4pa">
                    Diese Website wird über einen Hosting-Anbieter bereitgestellt. Der Anbieter
                    verarbeitet in unserem Auftrag personenbezogene Daten zur Bereitstellung der
                    Website (Art. 28 DSGVO).
                  </p>
                </section>

                <section data-id="element-489" data-mp="acwnl80smyo9">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-490" data-mp="adoishqhaue0">
                    5) Kontaktaufnahme
                  </h2>
                  <p className="mt-2" data-id="element-491" data-mp="f9wutm9dq7gy">
                    Bei der Kontaktaufnahme per E-Mail oder über Kontaktformulare werden
                    personenbezogene Daten gespeichert (Name, E-Mail-Adresse, Nachricht). Die
                    Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage
                    vertragsbezogen ist oder gemäß Art. 6 Abs. 1 lit. f DSGVO basierend auf unserem
                    berechtigten Interesse an der Beantwortung Ihrer Anfrage.
                  </p>
                </section>

                <section data-id="element-492" data-mp="6buocr6vmmma">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-493" data-mp="6c2ywcfj1fub">
                    6) Mitgliederbereich via Memberspot
                  </h2>
                  <p className="mt-2" data-id="element-494" data-mp="1hpyramvfzl3h">
                    Für die Bereitstellung unseres Mitgliederbereichs nutzen wir den Dienst
                    „Memberspot“. Dabei werden Ihre Daten (z. B. E-Mail, Name, Kursfortschritt) an die
                    Memberspot GmbH übermittelt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO
                    (Vertragserfüllung).
                  </p>
                </section>

                <section data-id="element-495" data-mp="2nil7l9t3y4fc">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-496" data-mp="2nj39on2gbcv6">
                    7) Zahlungsabwicklung über Ablefy
                  </h2>
                  <p className="mt-2" data-id="element-497" data-mp="2eiop5pxba1sq">
                    Die Zahlungsabwicklung erfolgt über den Zahlungsdienstleister{' '}
                    <strong className="font-semibold text-neutral-900" data-id="element-498" data-mp="29kmyaitn8y6p">Ablefy</strong>. Dabei werden
                    Zahlungsdaten (Name, E-Mail, Bestelldaten, Zahlungsart) an Ablefy übermittelt.
                    Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.
                  </p>
                </section>

                <section data-id="element-499" data-mp="2u6vque0zmcp">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-500" data-mp="37tfkwu3vuer0">
                    8) E-Mail-Marketing
                  </h2>
                  <p className="mt-2" data-id="element-501" data-mp="3cr7cto4j20v7">
                    Wenn Sie sich für unseren Newsletter anmelden, verwenden wir Ihre E-Mail-Adresse
                    zum Versand von Informationen zu unseren Angeboten. Die Einwilligung erfolgt über
                    ein Double-Opt-In-Verfahren. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO.
                    Abmeldung jederzeit möglich über den Abmeldelink im Newsletter.
                  </p>
                </section>

                <section data-id="element-502" data-mp="2f5a067ctwpr6">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-503" data-mp="2f5tg5iix542k">
                    9) Affiliate-Programm
                  </h2>
                  <p className="mt-2" data-id="element-504" data-mp="2k5o7fn6lvvo5">
                    Wir bieten ein Partnerprogramm an. Dafür verarbeiten wir: Name, E-Mail-Adresse,
                    Affiliate-Link und Klickverhalten, Verkaufserfolge (Cash Collected),
                    Provisionsansprüche. Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art.
                    6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. f DSGVO
                    (berechtigtes Interesse an der Durchführung des Partnerprogramms). Weitere
                    Informationen zur Ausgestaltung des Partnerprogramms finden sich in unserem{' '}
                    <strong className="font-semibold text-neutral-900" data-id="element-505" data-mp="2lkh7mxvwfxxz">Affiliate-Vertrag</strong>.
                  </p>
                </section>

                <section data-id="element-506" data-mp="2hivqv1g8uzii">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-507" data-mp="2hlrjqbd8iy03">
                    10) Einbettungen (YouTube, Social Media etc.)
                  </h2>
                  <p className="mt-2" data-id="element-508" data-mp="2qkwjfl0j8xdu">
                    Unsere Website kann Inhalte von Drittanbietern einbetten (z. B. YouTube-Videos,
                    Instagram-Feeds). Dabei kann es zur Übertragung personenbezogener Daten an diese
                    Anbieter kommen. Diese unterliegen der jeweiligen Datenschutzrichtlinie des
                    Anbieters.
                  </p>
                </section>

                <section data-id="element-509" data-mp="2u9vfl8ml4ljr">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-510" data-mp="2p8frf7p41yx5">
                    11) Ihre Rechte als betroffene Person
                  </h2>
                  <p className="mt-2" data-id="element-511" data-mp="2l970ealggf5a">Sie haben folgende Rechte:</p>
                  <ul className="mt-2 space-y-1" data-id="element-512" data-mp="3hw1veh2935kj">
                    <li data-id="element-513" data-mp="3cya3vo5iplgv">
                      <strong className="font-semibold text-neutral-900" data-id="element-514" data-mp="3cy0cpx8ql89l">Auskunft</strong> (Art. 15
                      DSGVO)
                    </li>
                    <li data-id="element-515" data-mp="385gzx2hvih5u">
                      <strong className="font-semibold text-neutral-900" data-id="element-516" data-mp="34686jyqqwlat">Berichtigung</strong> (Art.
                      16 DSGVO)
                    </li>
                    <li data-id="element-517" data-mp="4k1h4wpofowm">
                      <strong className="font-semibold text-neutral-900" data-id="element-518" data-mp="4kbbewhr8i84">Löschung</strong> (Art. 17
                      DSGVO)
                    </li>
                    <li data-id="element-519" data-mp="1ifjn6lk9ceht">
                      <strong className="font-semibold text-neutral-900" data-id="element-520" data-mp="1igck6utezpmr">
                        Einschränkung der Verarbeitung
                      </strong>{' '}
                      (Art. 18 DSGVO)
                    </li>
                    <li data-id="element-521" data-mp="1we9jw0360c5n">
                      <strong className="font-semibold text-neutral-900" data-id="element-522" data-mp="1wesu0umkpw94">
                        Datenübertragbarkeit
                      </strong>{' '}
                      (Art. 20 DSGVO)
                    </li>
                    <li data-id="element-523" data-mp="26bfcxdvcad8i">
                      <strong className="font-semibold text-neutral-900" data-id="element-524" data-mp="26amed06jau1g">
                        Widerspruch gegen die Verarbeitung
                      </strong>{' '}
                      (Art. 21 DSGVO)
                    </li>
                    <li data-id="element-525" data-mp="2k3vl0t33l1ga">
                      <strong className="font-semibold text-neutral-900" data-id="element-526" data-mp="2k4n3d27op2om">
                        Widerruf erteilter Einwilligungen
                      </strong>{' '}
                      (Art. 7 Abs. 3 DSGVO)
                    </li>
                    <li data-id="element-527" data-mp="p0ytle003ju4">
                      <strong className="font-semibold text-neutral-900" data-id="element-528" data-mp="oyckvb1diyab">
                        Beschwerde bei der Aufsichtsbehörde
                      </strong>
                    </li>
                  </ul>
                </section>

                <section data-id="element-529" data-mp="tzif5daomtly">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-530" data-mp="ty7evngg43zl">
                    12) Dauer der Speicherung
                  </h2>
                  <p className="mt-2" data-id="element-531" data-mp="13pv89twkbv3p">
                    Wir speichern personenbezogene Daten nur so lange, wie dies zur jeweiligen
                    Zweckerfüllung erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.
                  </p>
                </section>

                <section data-id="element-532" data-mp="3jgpvqgl8gk0o">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-533" data-mp="3jg7tn3bw3bku">13) Änderung</h2>
                  <p className="mt-2" data-id="element-534" data-mp="3eifzs3ropfe0">
                    Wir behalten uns das Recht vor, diese Datenschutzerklärung jederzeit zu ändern,
                    z. B. bei rechtlichen Änderungen oder Erweiterungen unserer Angebote.
                  </p>
                </section>

                <section data-id="element-535" data-mp="1k9sr04jip5zb">
                  <h2 className="font-heading text-base font-bold text-neutral-900" data-id="element-536" data-mp="1kakj35dwolku">14) Kontakt</h2>
                  <p className="mt-2" data-id="element-537" data-mp="1p840ge5wheh0">Für Fragen zum Datenschutz:</p>
                  <p data-id="element-538" data-mp="1b94bt6ie0zku">info@hotsalesgirls.com</p>
                </section>
              </div>
            </motion.div>
          </main>

          <Footer data-id="element-539" data-mp="1g98qqs3ndm8y" />
        </div>
      </div>
      <CookieBanner data-id="element-540" data-mp="1g64fxbvofs9b" />
    </div>;
}